import { render, staticRenderFns } from "./PendingPractitionerSubmissions.vue?vue&type=template&id=39850c43&scoped=true&"
import script from "./PendingPractitionerSubmissions.vue?vue&type=script&lang=js&"
export * from "./PendingPractitionerSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./PendingPractitionerSubmissions.vue?vue&type=style&index=0&id=39850c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39850c43",
  null
  
)

export default component.exports